import { styled, Text, spacing, mq } from '@thg-commerce/enterprise-theme'
import { Carousel } from '@thg-commerce/gravity-patterns'
import { Image } from '@thg-commerce/gravity-elements'
import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { ProductBlock } from '@thg-commerce/enterprise-components'
import { WishlistContainer } from '@thg-commerce/enterprise-widget-product-list-page/src/ProductItem'

export const Title = styled.h2<{ textAlign: string }>`
  ${Text('large1', 'alternate')};
  text-align: center;
  padding: 0 0 ${spacing(0.5)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    text-align: ${(props) => props.textAlign};
  }
`

export const Description = styled.p<{ textAlign: string }>`
  max-width: 500px;
  text-align: center;
  margin: 0 auto;
  ${Text('medium1', 'default')};
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    text-align: ${(props) => props.textAlign};
    ${Text('bodyText', 'default')};
    ${(props) => (props.textAlign === 'left' ? 'margin: 0' : '')};
  }
`

export const StyledCarousel = styled(Carousel)`
  ul {
    gap: 0 ${spacing(0.75)};
  }

  li {
    padding: 0;
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-left: 0;
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-top: ${spacing(2)};
  }
`

export const StyledGrid = styled(Grid)`
  grid-template-rows: 1fr;
  grid-column-gap: 0;
  max-width: 1100px;
  margin: 0 auto ${spacing(10)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    grid-column-gap: ${spacing(10)};
  }
`

export const StyledButtonGrid = styled(GridItem)<{ isPortrait: boolean }>`
  padding: 0;
  margin-top: ${spacing(2)};
  text-align: center;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: ${spacing(1)} 0;
    margin-top: ${(props) => (props.isPortrait ? `${spacing(6)}` : 0)};
  }
`

export const ProductBlockGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: ${spacing(1)};
  row-gap: ${spacing(5)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    row-gap: ${spacing(4)};
    margin-top: ${spacing(2)};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    margin-top: ${spacing(2)};
  }

  > a {
    height: fit-content;
  }
`

export const StyledProductBlock = styled(ProductBlock)<{ hasButton: boolean }>`
  > div:nth-of-type(2) > a,
  > div:nth-of-type(2) > div {
    padding-left: ${spacing(1)};
    > div > h3 {
      ${Text('medium1', 'default')};

      ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
        ${Text('bodyText', 'default')};
      }
    }

    ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
      padding-left: 0;
    }
  }
  div:nth-of-type(2) > div:last-child {
    ${(props) => props.hasButton && `padding : 0`};
  }
`

export const StyledGridItemContainer = styled(GridItem)`
  margin: 0 ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin: 0;
  }
`

export const StyledCarouselGrid = styled(GridItem)<{ displayAsGrid: boolean }>`
  ${(props) => !props.displayAsGrid && `margin-left: ${spacing(2)}`};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-left: 0;
  }

  a,
  a:hover {
    border: 0;
  }
`

export const StyledWishlistContainer = styled(WishlistContainer)`
  right: ${spacing(1)};
`

export const StyledImage = styled(Image)<{
  aspectRatio: string
  maxWidth?: string
}>`
  aspect-ratio: auto;
  display: flex;
  justify-content: center;

  img {
    ${(props) => props.aspectRatio && `aspect-ratio: ${props.aspectRatio};`}
    ${(props) => props.maxWidth && `max-width: ${props.maxWidth};`}
  }
`
